import { ref } from 'vue'

/** 全局登录弹窗状态（侧栏底部登录栏 + 内容区欢迎门共用）。 */
const open = ref(false)

export function useAuthModal() {
  return {
    open,
    openAuth() {
      open.value = true
    },
    closeAuth() {
      open.value = false
    }
  }
}
